// region import React
import React from 'react'
import FeatureGraph from 'components/featureGraph'
import featureData from 'components/display/data/featuredata.js'

class FeatureGraphs extends React.Component {
  static featureData = featureData

  render() {
    const appData = this.props.appData
    return (
      <>
        <div className='ui grid'>
          {FeatureGraphs.featureData.map(function iterator(data, i) {
            return (
              <FeatureGraph
                data={data}
                userAge={appData ? appData.user.age : false}
                userValue={
                  appData ? appData.user.featureProfile[data.key] : false
                }
                avgAge={appData ? appData.runningAge : false}
                avgValue={appData ? appData.runningAverage[data.key] : false}
                graphkey={data.key}
                key={i}
              />
            )
          }, this)}
        </div>
      </>
    )
  }
}

export default FeatureGraphs
